var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsScreens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Screens",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1698.615,
    height: 526.91,
    viewBox: "0 0 1698.615 526.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(413.598 0.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(0.78 0.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 800.98,
    height: 525.375,
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M1028.42,613.25c-.006-5.058-.243-204.942-.62-525.377l.62.62c-219.81.045-498.558.1-800.916.162h-.066l.782-.782c-.024,186.839-.045,364.644-.066,525.377l-.716-.716c471.289.42,794.561.71,800.982.716-6.415.006-329.693.294-800.982.716h-.716v-.716c-.018-160.733-.039-338.538-.063-525.377v-.779h.845c302.359.06,581.107.117,800.916.159h.62v.62C1028.66,408.308,1028.426,608.2,1028.42,613.25Z",
    transform: "translate(-226.659 -87.094)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(76.518 190.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(184.834 88.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M308.926,184.185l78.783,1.085c-.6,41.986-35.979,76.2-78.783,76.2-.153,0-.309,0-.461,0Z",
    transform: "translate(-308.465 -184.185)",
    fill: "#e66b99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(27.76 46.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M420.7,259.77a7.736,7.736,0,0,1-1.684.135l-4.818.126-17.6.2-.222,0-.144-.18c-7.029-8.857-16.1-20.281-25.989-32.743-7.682-9.8-14.867-18.957-20.95-26.717l.4.2c-9.486-.09-17.429-.162-23.185-.216l-6.487-.144a12.308,12.308,0,0,1-2.292-.159,12.663,12.663,0,0,1,2.292-.159q2.472-.054,6.487-.141c5.756-.054,13.7-.129,23.185-.216l.249,0,.159.2c6.124,7.727,13.354,16.851,21.087,26.607,9.807,12.527,18.8,24.015,25.771,32.917l-.366-.177,17.6.2c1.974.051,3.572.093,4.818.123A7.828,7.828,0,0,1,420.7,259.77Z",
    transform: "translate(-317.73 -199.758)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(108.008 115.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M395.494,223.219c0,.336-11.413.605-25.489.605s-25.492-.27-25.492-.605,11.413-.6,25.492-.6S395.494,222.887,395.494,223.219Z",
    transform: "translate(-344.513 -222.617)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(108.008 124.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M395.494,226.372c0,.333-11.413.6-25.489.6s-25.492-.27-25.492-.6,11.413-.605,25.492-.605S395.494,226.04,395.494,226.372Z",
    transform: "translate(-344.513 -225.767)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(94.043 0.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M356.955,231.938l-1.106,77.279c-42.8-.59-77.686-35.29-77.686-77.279,0-42.4,35.568-77.291,78.792-77.291s78.792,34.891,78.792,77.291Z",
    transform: "translate(-278.163 -154.647)",
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(70.933 4.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M341.589,204.128a5.118,5.118,0,0,1-1.366.321l-3.919.626c-3.616.506-8.422,1.181-14.154,1.986l-.231.033-.177-.171c-5.384-5.24-11.874-11.553-18.876-18.364-9.07-8.9-17.231-17-23.095-22.9-2.8-2.852-5.121-5.222-6.9-7.038a20.88,20.88,0,0,1-2.418-2.7,20.519,20.519,0,0,1,2.745,2.364c1.852,1.744,4.264,4.021,7.17,6.766,6.019,5.75,14.274,13.753,23.344,22.648,6.945,6.87,13.381,13.234,18.723,18.52l-.407-.138c5.753-.632,10.577-1.166,14.205-1.564,1.567-.144,2.873-.264,3.955-.36A5.072,5.072,0,0,1,341.589,204.128Z",
    transform: "translate(-270.45 -155.916)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M297.757,155.185c0,.333-11.413.6-25.489.6s-25.492-.27-25.492-.6,11.413-.605,25.492-.605S297.757,154.853,297.757,155.185Z",
    transform: "translate(-246.776 -154.58)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(0 9.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M297.757,158.333c0,.336-11.413.605-25.489.605s-25.492-.27-25.492-.605,11.413-.6,25.492-.6S297.757,158,297.757,158.333Z",
    transform: "translate(-246.776 -157.731)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(465.58 67.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M436.028,161.479l-.315-48.024A61.292,61.292,0,0,0,396.094,128.9,56.8,56.8,0,0,0,377,178.641a68.266,68.266,0,0,0,1.121,6.978c.012.057.021.111.033.168h.006l57.869-13.022Z",
    transform: "translate(-376.626 -113.455)",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M436.028,161.479l-.315-48.024A61.292,61.292,0,0,0,396.094,128.9,56.8,56.8,0,0,0,377,178.641a68.266,68.266,0,0,0,1.121,6.978c.012.057.021.111.033.168h.006l57.869-13.022Z",
    transform: "translate(-376.626 -113.455)",
    fill: "#ec6c99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(65.541 0.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M452,146.573a56.974,56.974,0,0,0-46.708-32.7c-.605-.06-1.216-.117-1.831-.162-.389-.027-.773-.066-1.168-.087q-1.717-.094-3.485-.1c-.054,0-.1-.006-.159-.006h-.009c-.048,0-.1,0-.144,0v.009h0l.312,48.027.075,11.284,57.884,12.632.069.015h0a57.008,57.008,0,0,0,1.285-12.452A62.333,62.333,0,0,0,452,146.573Z",
    transform: "translate(-398.501 -113.516)",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(65.541 0.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M452,146.573a56.974,56.974,0,0,0-46.708-32.7c-.605-.06-1.216-.117-1.831-.162-.389-.027-.773-.066-1.168-.087q-1.717-.094-3.485-.1c-.054,0-.1-.006-.159-.006h-.009c-.048,0-.1,0-.144,0v.009h0l.312,48.027.075,11.284,57.884,12.632.069.015h0a57.008,57.008,0,0,0,1.285-12.452A62.333,62.333,0,0,0,452,146.573Z",
    transform: "translate(-398.501 -113.516)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(4.634 65.306)",
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M436.042,135.251l-57.869,13.022A59.317,59.317,0,0,0,494,147.88l-57.884-12.629",
    transform: "translate(-378.173 -135.251)",
    fill: "#fa6c94"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(154.116 55.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M561.7,132.884c0,.431-29.917.782-66.816.782s-66.825-.351-66.825-.782,29.911-.779,66.825-.779S561.7,132.456,561.7,132.884Z",
    transform: "translate(-428.063 -132.105)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(154.116 40.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M561.7,127.8c0,.431-29.917.779-66.816.779s-66.825-.348-66.825-.779,29.911-.779,66.825-.779S561.7,127.369,561.7,127.8Z",
    transform: "translate(-428.063 -127.021)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(154.116 25.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M561.7,122.718c0,.431-29.917.779-66.816.779s-66.825-.348-66.825-.779,29.911-.782,66.825-.782S561.7,122.287,561.7,122.718Z",
    transform: "translate(-428.063 -121.936)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(154.116 70.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M561.7,137.614c0,.431-29.917.782-66.816.782s-66.825-.351-66.825-.782,29.911-.779,66.825-.779S561.7,137.183,561.7,137.614Z",
    transform: "translate(-428.063 -136.835)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(154.586 85.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M520.009,142.762c0,.431-20.548.782-45.893.782s-45.9-.351-45.9-.782,20.545-.779,45.9-.779S520.009,142.331,520.009,142.762Z",
    transform: "translate(-428.22 -141.983)",
    fill: "#ad5fb5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(473.024 263.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(6.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 13.766,
    height: 153.733,
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(33.093 52.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 13.766,
    height: 101.519,
    fill: "#e8505b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(59.669 19.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 13.766,
    height: 135.406,
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(86.244 5.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 13.766,
    height: 147.796,
    fill: "#e8505b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(112.82 55.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 13.766,
    height: 98.394,
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(139.395 74.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 13.766,
    height: 79.097,
    fill: "#e8505b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(165.97 15.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 13.766,
    height: 137.954,
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(192.546 40.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 13.766,
    height: 113.082,
    fill: "#e8505b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(219.121 20.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 13.766,
    height: 132.957,
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(245.697 63.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 13.766,
    height: 90.581,
    fill: "#e8505b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(272.272 45.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 13.766,
    height: 107.818,
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(0 163.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M670.767,234.305c0,.312-65.294.563-145.821.563-80.554,0-145.836-.252-145.836-.563s65.282-.566,145.836-.566C605.473,233.739,670.767,233.991,670.767,234.305Z",
    transform: "translate(-379.111 -233.739)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(5.723 175.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M401.452,238.343c0,.312-4.575.566-10.217.566s-10.214-.255-10.214-.566,4.572-.566,10.214-.566S401.452,238.032,401.452,238.343Z",
    transform: "translate(-381.021 -237.777)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(35.622 176.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M415.416,238.549c0,.312-5.465.566-12.21.566S391,238.861,391,238.549s5.465-.566,12.207-.566S415.416,238.238,415.416,238.549Z",
    transform: "translate(-391 -237.983)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(64.524 176.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M425.062,238.549c0,.312-5.465.566-12.207.566s-12.21-.255-12.21-.566,5.465-.566,12.21-.566S425.062,238.238,425.062,238.549Z",
    transform: "translate(-400.646 -237.983)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(93.425 176.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M434.708,238.549c0,.312-5.465.566-12.207.566s-12.21-.255-12.21-.566,5.465-.566,12.21-.566S434.708,238.238,434.708,238.549Z",
    transform: "translate(-410.292 -237.983)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(122.327 176.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M444.354,238.549c0,.312-5.465.566-12.207.566s-12.21-.255-12.21-.566,5.465-.566,12.21-.566S444.354,238.238,444.354,238.549Z",
    transform: "translate(-419.938 -237.983)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(151.229 176.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M454,238.549c0,.312-5.468.566-12.21.566s-12.21-.255-12.21-.566,5.465-.566,12.21-.566S454,238.238,454,238.549Z",
    transform: "translate(-429.584 -237.983)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(180.13 176.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M463.649,238.549c0,.312-5.468.566-12.21.566s-12.21-.255-12.21-.566,5.468-.566,12.21-.566S463.649,238.238,463.649,238.549Z",
    transform: "translate(-439.23 -237.983)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(209.035 176.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M473.293,238.549c0,.312-5.465.566-12.21.566s-12.207-.255-12.207-.566,5.465-.566,12.207-.566S473.293,238.238,473.293,238.549Z",
    transform: "translate(-448.877 -237.983)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(237.937 176.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M482.939,238.549c0,.312-5.465.566-12.207.566s-12.21-.255-12.21-.566,5.465-.566,12.21-.566S482.939,238.238,482.939,238.549Z",
    transform: "translate(-458.523 -237.983)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(266.838 176.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M492.585,238.549c0,.312-5.465.566-12.207.566s-12.21-.255-12.21-.566,5.465-.566,12.21-.566S492.585,238.238,492.585,238.549Z",
    transform: "translate(-468.169 -237.983)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(33.093 52.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 13.766,
    height: 101.519,
    fill: "#f0b9ce"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(86.244 5.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 13.766,
    height: 147.796,
    fill: "#f0b9ce"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(139.395 74.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 13.766,
    height: 79.097,
    fill: "#f0b9ce"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(192.546 40.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 13.766,
    height: 113.082,
    fill: "#f0b9ce"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(245.697 63.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 13.766,
    height: 90.581,
    fill: "#f0b9ce"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(87.838 74.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M277.056,129.139a13.251,13.251,0,1,1-13.249-13.249A13.25,13.25,0,0,1,277.056,129.139Z",
    transform: "translate(-250.554 -115.89)",
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(142.582 76.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M468.383,117.343c0,.431-44.677.779-99.775.779-55.116,0-99.783-.348-99.783-.779s44.668-.779,99.783-.779C423.706,116.564,468.383,116.912,468.383,117.343Z",
    transform: "translate(-268.825 -116.564)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(144.038 92.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M347.968,122.693a12.092,12.092,0,0,1-3.089.3c-1.99.093-4.872.177-8.429.249-7.119.141-16.95.228-27.808.228s-20.695-.087-27.811-.228c-3.56-.072-6.439-.156-8.428-.249a12.133,12.133,0,0,1-3.092-.3,11.859,11.859,0,0,1,3.092-.306c1.99-.093,4.869-.177,8.428-.249,7.116-.141,16.95-.228,27.811-.228s20.689.087,27.808.228c3.557.072,6.439.156,8.429.249A11.82,11.82,0,0,1,347.968,122.693Z",
    transform: "translate(-269.311 -121.911)",
    fill: "#ad5fb5"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(0 35.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(0.782 0.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 395.467,
    height: 478.431,
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M477.589,582.178s-.025-.779-.037-2.274q-.013-2.274-.037-6.649c-.017-5.872-.042-14.538-.076-25.821-.04-22.589-.1-55.643-.173-97.617-.079-83.886-.192-203.405-.328-346.071l.65.689-395.51.09h-.04l.735-.779c-.042,176.388-.079,340.878-.113,478.432l-.622-.659,286.9.339c34.573.075,61.7.132,80.217.171,9.248.033,16.338.06,21.141.075s7.294.075,7.294.075-2.411.048-7.158.072c-4.778.018-11.829.045-21.025.078-18.478.039-45.562.1-80.073.171l-287.293.339h-.622v-.659c-.034-137.554-.074-302.044-.116-478.432v-.779h.777l395.51.09h.65v.689c-.136,142.848-.249,262.521-.328,346.514-.073,41.908-.13,74.909-.17,97.461-.034,11.224-.059,19.844-.079,25.687q-.021,4.324-.037,6.574C477.615,581.45,477.589,582.178,477.589,582.178Z",
    transform: "translate(-81.302 -102.967)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(52.206 234.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M406.733,191.952c-.128.285-4.309-2.328-12.515-5.124a74.484,74.484,0,0,0-59.564,5.324c-8.028,4.333-15.678,10.759-23.278,18.031-7.631,7.254-15.208,15.491-23.946,23.107-8.743,7.491-18.772,14.58-30.569,17.819a43.007,43.007,0,0,1-17.845,1.157,54.881,54.881,0,0,1-16.538-5.5c-10.251-5.2-19.016-12.042-27.7-17.744-8.621-5.816-17.289-10.427-26.054-12.581a72.058,72.058,0,0,0-24.783-2.046,76.084,76.084,0,0,0-34.211,12c-7.341,4.833-10.8,8.467-11,8.213a17.972,17.972,0,0,1,2.487-2.634,60.169,60.169,0,0,1,7.962-6.523,74.562,74.562,0,0,1,34.586-13.07,72.709,72.709,0,0,1,25.473,1.756c9.052,2.109,18.1,6.834,26.819,12.635,8.8,5.7,17.567,12.449,27.515,17.447,9.85,5.109,21.434,7.383,32.642,4.114,11.208-3.065,20.989-9.9,29.587-17.231,8.6-7.443,16.212-15.628,23.957-22.9,7.714-7.284,15.581-13.795,23.9-18.169a75.05,75.05,0,0,1,24.4-8.078,73.266,73.266,0,0,1,36.486,3.814,61.2,61.2,0,0,1,9.194,4.261A16.9,16.9,0,0,1,406.733,191.952Z",
    transform: "translate(-98.726 -181.159)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(17.841 18.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(41.701 56.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 35.639,
    height: 96.388,
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(178.439 56.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 35.639,
    height: 96.388,
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(224.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 35.639,
    height: 152.992,
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(0 122.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 35.639,
    height: 32.439,
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(87.28 100.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 35.64,
    height: 52.862,
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(132.861 87.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 35.639,
    height: 64.997,
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(18.178 181.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(40.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M158.1,243.122c0,.791-8.62,1.432-19.254,1.432s-19.257-.641-19.257-1.432,8.62-1.432,19.257-1.432S158.1,242.331,158.1,243.122Z",
    transform: "translate(-119.594 -241.69)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M143.3,243.122c0,.791-8.623,1.432-19.257,1.432s-19.254-.641-19.254-1.432,8.62-1.432,19.254-1.432S143.3,242.331,143.3,243.122Z",
    transform: "translate(-104.793 -241.69)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(222.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M230.613,243.122c0,.791-9.747,1.432-21.765,1.432s-21.768-.641-21.768-1.432,9.744-1.432,21.768-1.432S230.613,242.331,230.613,243.122Z",
    transform: "translate(-187.081 -241.69)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(174.965 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 21.767,
    cy: 1.432,
    rx: 21.767,
    ry: 1.432,
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(130.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M191.275,243.122c0,.791-8.623,1.435-19.254,1.435s-19.257-.644-19.257-1.435,8.62-1.432,19.257-1.432S191.275,242.331,191.275,243.122Z",
    transform: "translate(-152.764 -241.69)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(82.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M173.892,243.122c0,.791-8.623,1.435-19.254,1.435s-19.257-.644-19.257-1.435,8.62-1.432,19.257-1.432S173.892,242.331,173.892,243.122Z",
    transform: "translate(-135.381 -241.69)",
    fill: "#ad5fb5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(45.465 70.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 291.264,
    height: 120.959,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(33.356 24.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M142.688,148.312a13.577,13.577,0,1,1-13.576-13.579A13.578,13.578,0,0,1,142.688,148.312Z",
    transform: "translate(-115.533 -134.733)",
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(40.733 4.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 94.61,
    height: 5.253,
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(40.733 16.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 184.046,
    height: 5.253,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(33.356 66.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M142.688,162.244a13.577,13.577,0,1,1-13.576-13.579A13.578,13.578,0,0,1,142.688,162.244Z",
    transform: "translate(-115.533 -148.665)",
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    transform: "translate(40.733 4.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 48.313,
    height: 5.253,
    fill: "#ad5fb5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(40.733 16.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 184.046,
    height: 5.253,
    fill: "#fff"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(1236.803 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(0.781 0.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 460.343,
    height: 525.375,
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M968.227,600.459s-.027-.854-.039-2.5q-.013-2.485-.039-7.3c-.018-6.442-.045-15.955-.081-28.347-.042-24.8-.1-61.093-.183-107.187-.084-92.116-.2-223.375-.347-380.048l.689.686-460.3.093h-.045l.779-.779c-.045,193.694-.087,374.322-.12,525.374l-.659-.659,333.912.339c40.236.075,71.808.132,93.347.171,10.763.033,19.014.06,24.6.078s8.482.072,8.482.072-2.813.048-8.339.072c-5.558.018-13.765.045-24.473.078-21.5.039-53.027.1-93.2.171l-334.331.339h-.659v-.659c-.036-151.052-.078-331.68-.123-525.374V74.3h.827l460.3.093h.689v.689c-.144,156.856-.264,288.267-.347,380.491-.078,46.025-.138,82.267-.18,107.031-.036,12.332-.063,21.8-.081,28.212l-.042,7.221C968.254,599.659,968.227,600.459,968.227,600.459Z",
    transform: "translate(-507.104 -74.303)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(37.61 42.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 372.925,
    height: 299.159,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(26.062 37.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(0 208.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 12.239,
    height: 3.527,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(27.689 226.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 15.652,
    height: 3.527,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(82.176 226.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 15.652,
    height: 3.527,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(136.663 226.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 15.652,
    height: 3.527,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(191.15 226.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 15.652,
    height: 3.527,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    transform: "translate(245.637 226.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 15.652,
    height: 3.527,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(300.124 226.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 15.652,
    height: 3.527,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(0 160.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 12.239,
    height: 3.527,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(0 72.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 12.239,
    height: 3.527,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(0 27.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 12.239,
    height: 3.527,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(0.62 116.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 12.239,
    height: 3.527,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(17.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M831.8,312.814a8,8,0,0,1-1.312.078l-3.85.078c-3.467.036-8.44.084-14.81.147l-54.465.249c-46.055.057-109.554.138-179.693.228-14.586,0-28.887-.009-42.582-.012h-.77v-.767c.1-60.068.2-112.934.264-150.869.1-18.873.177-34.031.231-44.551.06-5.16.1-9.18.135-11.994.03-1.309.051-2.337.069-3.1a5.932,5.932,0,0,1,.072-1.055,5.957,5.957,0,0,1,.072,1.055c.018.767.039,1.795.069,3.1.033,2.813.075,6.834.135,11.994.054,10.52.132,25.678.231,44.551.066,37.935.159,90.8.264,150.869l-.77-.77c13.7,0,28-.006,42.582-.012,70.139.09,133.638.171,179.693.228,22.939.1,41.528.192,54.465.249,6.37.063,11.344.114,14.81.147l3.85.078A8.167,8.167,0,0,1,831.8,312.814Z",
    transform: "translate(-534.313 -101.241)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    transform: "translate(30.461 117.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M826.845,141.268c0,.432-64.548.779-144.155.779-79.634,0-144.17-.348-144.17-.779s64.536-.779,144.17-.779C762.3,140.489,826.845,140.837,826.845,141.268Z",
    transform: "translate(-538.521 -140.489)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(30.461 73.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M826.845,126.473c0,.431-64.548.782-144.155.782-79.634,0-144.17-.351-144.17-.782s64.536-.779,144.17-.779C762.3,125.694,826.845,126.042,826.845,126.473Z",
    transform: "translate(-538.521 -125.694)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    transform: "translate(30.461 28.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M826.845,111.6c0,.431-64.548.782-144.155.782-79.634,0-144.17-.351-144.17-.782s64.536-.779,144.17-.779C762.3,110.824,826.845,111.175,826.845,111.6Z",
    transform: "translate(-538.521 -110.824)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(30.461 161.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M826.845,156.065c0,.428-64.548.779-144.155.779-79.634,0-144.17-.351-144.17-.779s64.536-.782,144.17-.782C762.3,155.283,826.845,155.634,826.845,156.065Z",
    transform: "translate(-538.521 -155.283)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    transform: "translate(33.433 3.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M539.513,301.1V261.767l24.515-38.055,16.632,12.761,34.145-53.036,20.135,14.181,28.015-48.925,22.762,18.544,34.145-64.9,36.77,72.542,29.765-36.3,35.02-10.022V301.1Z",
    transform: "translate(-539.513 -102.332)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(33.433 15.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M824.865,106.713a2.486,2.486,0,0,1-.617.06l-1.825.057-7.107.114-26.873.2.344-.171c-7.829,10.256-17.564,23.005-28.755,37.669l-.186.24h-.305l-72.1.132.644-.363c-9.489,15.8-19.721,32.845-30.3,50.466-10.328,17.159-20.324,33.771-29.765,49.459l-.587.974-.665-.917c-14.232-19.589-27.392-37.7-39.029-53.719l1.052-.033c-14.84,23.068-27.092,42.109-35.685,55.466-4.27,6.559-7.628,11.718-9.974,15.32l-2.655,3.994c-.611.9-.965,1.33-.965,1.33s.246-.506.8-1.435c.608-1,1.438-2.355,2.5-4.093l9.681-15.506c8.482-13.429,20.575-32.572,35.227-55.76l.5-.788.554.755c11.688,15.973,24.914,34.043,39.212,53.582l-1.249.054c9.423-15.694,19.4-32.317,29.717-49.486,10.6-17.612,20.851-34.645,30.355-50.436l.219-.366.422,0,72.1.132-.488.24c11.308-14.574,21.139-27.248,29.049-37.441l.132-.171h.21l26.873.2,7.107.114,1.825.057A2.311,2.311,0,0,1,824.865,106.713Z",
    transform: "translate(-539.513 -106.279)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(88.462 109.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M563.41,140.384a2.767,2.767,0,1,1-2.765-2.664A2.715,2.715,0,0,1,563.41,140.384Z",
    transform: "translate(-557.879 -137.72)",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(171.619 62.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M591.164,124.609a2.768,2.768,0,1,1-2.765-2.664A2.716,2.716,0,0,1,591.164,124.609Z",
    transform: "translate(-585.633 -121.945)",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    transform: "translate(236.266 50.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M612.743,120.733a2.769,2.769,0,1,1-2.769-2.664A2.718,2.718,0,0,1,612.743,120.733Z",
    transform: "translate(-607.209 -118.069)",
    fill: "#e8505b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(42.229 385.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M872.695,203.791c0,.431-78.69.779-175.741.779-97.081,0-175.756-.348-175.756-.779s78.675-.779,175.756-.779C794,203.012,872.695,203.36,872.695,203.791Z",
    transform: "translate(-521.198 -203.012)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(42.229 404.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M872.695,210.133c0,.431-78.69.779-175.741.779-97.081,0-175.756-.348-175.756-.779s78.675-.779,175.756-.779C794,209.354,872.695,209.7,872.695,210.133Z",
    transform: "translate(-521.198 -209.354)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(42.229 423.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M872.695,216.475c0,.431-78.69.782-175.741.782-97.081,0-175.756-.351-175.756-.782s78.675-.779,175.756-.779C794,215.7,872.695,216.047,872.695,216.475Z",
    transform: "translate(-521.198 -215.696)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(42.229 442.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M872.695,222.82c0,.431-78.69.779-175.741.779-97.081,0-175.756-.348-175.756-.779s78.675-.782,175.756-.782C794,222.038,872.695,222.389,872.695,222.82Z",
    transform: "translate(-521.198 -222.038)",
    fill: "#263238"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsScreens);
export default __webpack_public_path__ + "static/media/StatsScreens.9a8ccaa3c16a5ded5f9dba72d76e0128.svg";
export { ForwardRef as ReactComponent };